import React from "react";
import { ComponentProps } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { Link } from "../../elements/Link/Link";

import * as styles from "./ScientistOfTheDayIndex.module.css";

interface Props extends ComponentProps {
  scientistLinks?: any;
  labels: {
    label: string;
    disabled?: boolean;
  }[];
  currentLabel: number;
  handleLabelClick: (idx: number) => void;
}

export const ScientistOfTheDayIndex: React.FC<Props> = ({
  scientistLinks,
  labels,
  handleLabelClick,
  currentLabel,
  ...props
}) => {
  const renderScientistLinks = () => {
    let skipToIndex = 0;

    return scientistLinks?.map((link, idx) => {
      if (idx < skipToIndex) return;

      const links = [<Link to={link.url}>{link.title.trim()}</Link>];

      let nextIdx = idx + 1;
      let nextScientist = scientistLinks[nextIdx];

      while (
        nextIdx < scientistLinks.length &&
        nextScientist?.title.trim() === link.title.trim()
      ) {
        const splitUrl = nextScientist.url.split("-");
        links.push(
          <>
            {" "}
            <Link to={nextScientist.url}>
              {nextScientist.year}
              {/* {splitUrl[splitUrl.length - 1]} */}
            </Link>
          </>
        );
        skipToIndex = nextIdx + 1;
        nextIdx++;
        nextScientist = scientistLinks[nextIdx];
      }

      return <div>{links}</div>;
    });
  };

  return (
    <SectionWrapper {...props}>
      <div className={styles.scientistOfTheDayIndex}>
        <div className={styles.labels}>
          {labels.map((label, idx) => {
            if (label.disabled && label.label === "#") return null;
            return (
              <button
                onClick={() => handleLabelClick(idx)}
                key={`labelIdx--${idx}`}
                className={
                  idx === currentLabel
                    ? `${styles.letterButton} ${styles.selected}`
                    : styles.letterButton
                }
                disabled={label.disabled}
              >
                {label.label.toUpperCase()}
              </button>
            );
          })}
        </div>
        <div className={styles.links}>{renderScientistLinks()}</div>
      </div>
    </SectionWrapper>
  );
};
